import { render } from "./CallToActionSection.vue?vue&type=template&id=0859e4c9&scoped=true"
import script from "./CallToActionSection.vue?vue&type=script&lang=js"
export * from "./CallToActionSection.vue?vue&type=script&lang=js"

import "./CallToActionSection.vue?vue&type=style&index=0&id=0859e4c9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0859e4c9"]])

export default __exports__